import { render, staticRenderFns } from "./TeamRatingsInfo.vue?vue&type=template&id=7341bbbc&scoped=true"
import script from "./TeamRatingsInfo.vue?vue&type=script&lang=js"
export * from "./TeamRatingsInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamRatingsInfo.vue?vue&type=style&index=0&id=7341bbbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7341bbbc",
  null
  
)

export default component.exports